import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { Delibera } from '../../model/delibere-data';
import { ProvvisorioDettaglioListaDto, GruppoValore, ListaProvvisoriDto } from '../../model/iscritti-data';
import { DeliberaService } from '../../services/delibera.service';
import { IscrittiService } from '../../services/iscritti.service';
import { PrintService } from '../../services/print.service';
import { DialogDeliberaComponent } from '../dialog-delibera/dialog-delibera.component';
import { RoleService } from '../../services/role.service';
import { CustomFiltersService } from '../../services/custom-filters.service';
import { SearchFilters, TableSettings } from '../../model/filters-data';

@Component({
  selector: 'app-tabella-delibere-trasf',
  templateUrl: './tabella-delibere-trasf.component.html',
  styleUrl: './tabella-delibere-trasf.component.scss'
})
export class TabellaDelibereTrasfComponent implements OnInit{

  @ViewChild('dt') dt!: Table;

  resetFlag: boolean = false;
  initialFlagHandler: boolean = true;

  //dialog dati
  ref: DynamicDialogRef | undefined;

  //services
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private iscritti_service = inject(IscrittiService);
  private delibera_service = inject(DeliberaService);
  private dialog_service = inject(DialogService);
  private message_service = inject(MessageService);
  private print_service = inject(PrintService);
  private custom_filters_service = inject(CustomFiltersService);
  public role_service = inject(RoleService);

  //gestione del componente
  tipoLista: string = '';
  componente: string = '';
  sezione: string = '';
  deliberaCorrente: Delibera | undefined;

  keyDataCheckbox = "codiceFiscale";
  provvisoriSelezionati: ProvvisorioDettaglioListaDto[] = [];

  //filtro generale per tutti i tipi di tabella
  filtri = new FormGroup({
    inserimento: new FormControl<string|null>('')
  })

  sezioniOptions: GruppoValore[] = [
    { nome: 'Sezione A', valore: 'A' },
    { nome: 'Sezione B', valore: 'B' }
  ]

  //dati della tabella
  headersTabella: string[] = ['Verificato', 'Codice Fiscale', 'Data Domanda', 'Nome', 'Cognome', 'Sezione', 'N° Iscrizione', 'Riepilogo Iscrizione', 'Pec']
  rowsTabella: string[] = ['provvisorioVerificato', 'codiceFiscale', 'domandaData', 'nome', 'cognome', 'sezioneAlbo', 'numeroIscrizione', 'numeroDelibera', 'pec']
  listaProvvisori: ProvvisorioDettaglioListaDto[] = [];

  dettaglioIscrittoRoute = '/gestione-albo/gestione-iscritti/dettaglio-iscritto/';

  orderColumnName: string = '';
  order: string = '';
  page: number = 0;
  pageSize: number = 25;
  currentPage: number = 0;

  totaleDati: number = 0;
  
  disabledCompila: boolean = true;

  get provvisoriVisibili(): any[] {
    return this.listaProvvisori;
  }

  ngOnInit(): void {

    this.initialDataHandler();

    this.filtri.valueChanges.subscribe(() => {
      this.resetPagination();
      this.loadData();
    })
    this.pulsanteDinamicoDisable();

  }


  //gestione dei dati iniziali
  private initialDataHandler(){

    const componente: string = this.route.snapshot.data['componente'];
    const iscritti: ListaProvvisoriDto = this.route.snapshot.data[componente];
    this.deliberaCorrente = this.route.snapshot.data['delibera'];

    this.componente = componente;

    this.listaProvvisori = iscritti.lista;
    this.totaleDati = iscritti.conteggio;
    this.tipoLista = componente;

    this.provvisoriSelezionati = this.listaProvvisori.filter((provvisorio: ProvvisorioDettaglioListaDto) => provvisorio.numeroDelibera !== null && provvisorio.numeroDelibera === this.deliberaCorrente?.numeroDelibera)

    this.inizializzaFiltri();

  }

  //gestisce il caricamento della tabella quando siamo sul componente
  private loadData(){

    const values = this.filtri.value;

    const tabData: TableSettings = {
      orderColumnName: this.orderColumnName,
      order: this.order,
      page: this.page,
      pageSize: this.pageSize,
      currentPage: this.currentPage
    }

    const data: SearchFilters = this.custom_filters_service.sessionStorageUpdate(values, this.componente, tabData);

    this.iscritti_service.getProvvisori(data).subscribe({
      next: (result: ListaProvvisoriDto) => {
        this.listaProvvisori = result.lista;
        this.totaleDati = result.conteggio;
        this.pulsanteDinamicoDisable();
      },
      error: (error) => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Operazione interrotta.' });
      }
    })
  }

  //resertta paginazione
  resetPagination(){
    this.orderColumnName = 'codiceFiscale';
    this.order = 'ASC';
    this.pageSize = 25;
    this.page = 0;
    this.currentPage = 0;
  }

  //crea il RouterLink per le voci della tabella
  generaRoutingLink(iscritto: any): string{
    return this.dettaglioIscrittoRoute + iscritto.id;
  }

  //cambio pagina della tabella
  pageChange(event: any){
    this.currentPage = event.first;
    this.page = event.page;
    this.pageSize = event.rows;

    this.loadData();
  }

  ordinamento(event: any){

    if(this.initialFlagHandler){
      this.initialFlagHandler = false;
      return;
    }

    this.orderColumnName = event.sortField ? event.sortField : 'codiceFiscale';
    this.order = event.sortOrder === 1 ? 'ASC' : 'DESC'; //-1 discendente / 1 ascendente
    this.pageSize = 25;
    this.page = 0;
    this.currentPage = 0;

    if(this.resetFlag){
      this.resetFlag = false;
      this.dt.reset();
      return;
    }

    //if(event.sortOrder === -1) this.resetFlag = true;

    this.loadData();
  }

  //resetta i lbox di ricerca
  resetBoxRicerca(){
    this.filtri.get('inserimento')?.setValue('')
  }

  //resetta i filtri di ricerca
  clearFilters(){

    this.resetPagination();

    this.filtri.patchValue({
      inserimento: ''
    })

    this.dt.reset();

    this.loadData();

  }

  //aggiorna il session storage
  sessionStorageUpdate(){

    // const values = this.filtri.value;
    // const sessionData = JSON.parse(sessionStorage.getItem('data')!);

    // sessionData[this.componente].inserimento = values.inserimento;
    // sessionData[this.componente].sezione = values.sezione?.valore;
    // sessionData[this.componente].orderColumn = this.orderColumnName;
    // sessionData[this.componente].order = this.order;
    // sessionData[this.componente].page = this.pageSelected;
    // sessionData[this.componente].pageSize = this.pageSize;
    // sessionData[this.componente].currentPage = this.currentPage;

    // sessionStorage.setItem(`data`, JSON.stringify(sessionData));

  }

  //inizializza i filtri sul routing
  inizializzaFiltri(){

    const sessionData = JSON.parse(sessionStorage.getItem('data')!)[this.componente];

    const str: string = sessionData.inserimento;

    this.filtri.patchValue({
      inserimento: str
    });

    this.orderColumnName = sessionData.orderColumn;
    this.order = sessionData.order;
    this.currentPage = Number(sessionData.currentPage);
    this.page = Number(sessionData.page);
    this.pageSize = Number(sessionData.pageSize);

    const tabData: TableSettings = {
      orderColumnName: this.orderColumnName,
      order: this.order,
      page: this.page,
      pageSize: this.pageSize,
      currentPage: this.currentPage
    }

    this.custom_filters_service.sessionStorageUpdate(this.filtri.value, this.componente, tabData);

  }

  //gestisce la possibilità di aggiungere iscritti in altre delibere
  disableSingleCheckbox(item: ProvvisorioDettaglioListaDto){
    if(this.deliberaCorrente?.stampa){
      return true;
    }
    if(!this.deliberaCorrente?.stampa && item.numeroDelibera){
      if(item.numeroDelibera !== this.deliberaCorrente!.numeroDelibera) return true;
    }
    return false;
  }
  //gestione selezione provvisorio
  selezioneIscritto(event: Event, iscritto: ProvvisorioDettaglioListaDto){
    this.impedisciPropagazione(event);
    (iscritto.numeroDelibera === null) ? this.inserisci(iscritto.id) : this.rimuovi(iscritto.id);
  }
  //invio provvisorio in delibera
  inserisci(idIscritto: number){
    this.delibera_service.inserisciIscrittoInDelibera(idIscritto, this.deliberaCorrente?.id!).subscribe({
      complete: () => {
        this.loadData();
      },
      error: () => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Provvisorio non aggiunto a riepilogo.' });
      }
    });
  }
  // //rimuovi provvisorio da delibera
  rimuovi(idIscritto: number){
    this.delibera_service.rimuoviIscrittoDaDelibera(idIscritto, this.deliberaCorrente?.id!).subscribe({
      complete: () => {
        this.loadData();
      },
      error: () => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Provvisorio non rimosso dal riepilogo.' });
      }
    });
  }
  //selezione/deselezione massiva
  selezioneMassiva(check: any){
    const idIscritti: number[] = [];
    this.provvisoriVisibili.forEach(provvisorio => idIscritti.push(provvisorio.id));
    check.checked ? this.inserisciTuttiInDelibera(idIscritti) : this.svuotaDelibera(idIscritti);
  }
  //inserimento massivo in delibera
  inserisciTuttiInDelibera(idIscritti: number[]){
    this.delibera_service.inserimentoMassivoInDelibera(idIscritti, this.deliberaCorrente?.id!).subscribe({
      complete: () => {
        this.loadData();
      },
      error: () => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Inserimento in riepilogo interroto!' });
      }
    })
  }
  //svuota delibera
  svuotaDelibera(idIscritti: number[]){
    this.delibera_service.svuotaDelibera(idIscritti, this.deliberaCorrente?.id!).subscribe({
      complete: () => {
        this.loadData();
      },
      error: () => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Impossibile svuotare il riepilogo' });
      }
    })
  }
  checkAllProvvisori(){
    const filtro = this.listaProvvisori.filter(prov => prov.numeroDelibera === null);
    if(this.listaProvvisori.length > 0 && filtro.length == 0){
      return true;
    }
    return false;
  }
  //gestisce il disable dei bottoni per i provvisori
  pulsanteDinamicoDisable(){
    this.delibera_service.checkCompilaBozza(this.deliberaCorrente?.id!).subscribe({
      next: (response: boolean) => {
        this.disabledCompila = !response;
      }
    })
  }

  //gestisce il dialog delle delibere
  gestisciDeliberaDialog(operazione: string){

    this.ref = this.dialog_service.open(DialogDeliberaComponent, {
      data: {
        id: this.deliberaCorrente!.id,
        numeroDelibera: this.deliberaCorrente!.numeroDelibera,
        operazione: operazione
      },
      header: `${operazione} Riepilogo`
    });

    this.ref.onClose.subscribe({
      next: (result) => {

        if(result){

          if(result.esito){

            let tipoEsito: string = '';

            if(operazione === 'Compila') tipoEsito = 'compilato';
            if(operazione === 'Modifica') tipoEsito = 'modificato';
            if(operazione === 'Approva') tipoEsito = 'approvato';
            if(operazione === 'Cancella') tipoEsito = 'cancellato';

            if(operazione === 'Modifica'){
              this.message_service.add({
                severity: 'success',
                summary: `Operazione completata`,
                detail: `Modifica abilitata con successo.`
              });
            }
            else{
              this.message_service.add({
                severity: 'success',
                summary: `Operazione completata`,
                detail: `Riepilogo ${tipoEsito} con successo.`
              });
            }

            setTimeout(() => {

              if(operazione === 'Compila'){
                this.deliberaCorrente = result.delibera;
              }

              if(operazione === 'Cancella'){
                //this.deliberaCorrente = result.delibera;
                this.router.navigate(['/delibere/gestione']);
              }

              if(operazione === 'Modifica'){
                this.deliberaCorrente = result.delibera;
              }

              if(operazione === 'Approva'){
                this.router.navigate(['/delibere/finalizzazione']);
              }

            }, 1000)

          }

          if(!result.esito){
            this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Operazione interrotta.' });
          }

        }

      },
      complete: () => {
        if(operazione === 'Nuova' || operazione === 'Compila' || operazione === 'Modifica') this.loadData();
      },
      error: (errore) => {
        this.message_service.add({ severity: 'error', summary: 'Qualcosa è andato storto', detail: 'Operazione interrotta.' });
      }
    })
  }

  //checkbox stop propagazione
  impedisciPropagazione(event: Event){
    event.stopPropagation();
  }

  iscrittoNonSelezionabile(iscritto: ProvvisorioDettaglioListaDto): boolean{

    if((!this.deliberaCorrente?.stampa && iscritto.numeroDelibera) || this.deliberaCorrente?.stampa){
      if(iscritto.numeroDelibera !== this.deliberaCorrente!.numeroDelibera) return false;
    }

    return true
  }

  mandaInStampa(){

    const idDelibera = this.deliberaCorrente?.id;
    const sezioneDelibera = this.deliberaCorrente?.tipo;

    this.print_service.stampaIscrizione(idDelibera!, sezioneDelibera?.codice.toLowerCase()!, true).subscribe({
      next: result => {
        const blob = new Blob([result], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        // const a = document.createElement('a');
        // a.href = url;
        // a.download = 'delibera_iscrizione_sezione_a.pdf';
        // document.body.appendChild(a);
        // a.click();
        // window.URL.revokeObjectURL(url);
        // document.body.removeChild(a);
      },
      error: err => {
        console.log(err.error);
      }
    })
  }

  orderCustom(order: string): number{

    let check = 0;
    if(order === 'ASC') check = 1;
    if(order === 'DESC') check = -1;

    return check;
  }

}
